module.exports = __webpack_public_path__ + "img/pptx.0fe178a7.svg";